export default __webpack_public_path__ + "static/media/inclinedplane.ad3f357f.jpg";